import { Box, Typography } from '@mui/material';
import React from 'react';

interface Props {
    onClick?: () => void
}

const SHLogo : React.FC<Props> = ({onClick}) => {
    return <Box sx={{paddingRight: '1em', maxWidth: '9em', margin: '0 auto'}} onClick={onClick}>
        <Box sx={{display: 'flex', justifyContent: 'center'}}>
            <Box sx={{padding: '0 0.5em', alignContent: 'center'}}>
                <Typography variant="caption" component="div" sx={{flexGrow: 1}} className="c-page-title">Stefan</Typography>
            </Box>
        </Box>
        <Box sx={{display: 'flex', justifyContent: 'center', margin: '-0.3em', borderTop: '1px solid #515151'}}>
            <Box sx={{padding: '0 0.5em', alignContent: 'center'}}>
                <Typography variant="caption" component="div" sx={{flexGrow: 1}} className="c-page-title">Hasenberg</Typography>
            </Box>
        </Box>
    </Box>
}

export default SHLogo;